
export const config = {
  apiUrl: 'https://flora-app.q-con.eu/api',
  webUrl: 'https://flora-app.q-con.eu',
}